"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CantAssignUserToPolicyWarning = exports.PolicyAssignmentRole = exports.PolicyBillingType = exports.PolicyNFType = exports.OriginatedVia = exports.PolicyStage = exports.PolicyStatus = exports.SecondaryCancellationReason = exports.PrimaryCancellationReason = void 0;
var PrimaryCancellationReason;
(function (PrimaryCancellationReason) {
    PrimaryCancellationReason["CARRIER_CANCELLED_POLICY"] = "CARRIER_CANCELLED_POLICY";
    PrimaryCancellationReason["CUSTOMER_REQUESTED_CANCEL"] = "CUSTOMER_REQUESTED_CANCEL";
    PrimaryCancellationReason["POLICY_LOST_BOR"] = "POLICY_LOST_BOR";
    PrimaryCancellationReason["POLICY_NOT_RENEWING_CARRIER"] = "POLICY_NOT_RENEWING_CARRIER";
    PrimaryCancellationReason["POLICY_NOT_RENEWING_CUSTOMER_REQUEST"] = "POLICY_NOT_RENEWING_CUSTOMER_REQUEST";
    PrimaryCancellationReason["POLICY_NOT_RENEWING_NEWFRONT"] = "POLICY_NOT_RENEWING_NEWFRONT";
})(PrimaryCancellationReason = exports.PrimaryCancellationReason || (exports.PrimaryCancellationReason = {}));
var SecondaryCancellationReason;
(function (SecondaryCancellationReason) {
    SecondaryCancellationReason["CANCEL_REWRITE"] = "CANCEL_REWRITE";
    SecondaryCancellationReason["CLIENT_CANCELLED_TWICE_FOR_NON_PAY"] = "CLIENT_CANCELLED_TWICE_FOR_NON_PAY";
    SecondaryCancellationReason["CLIENT_PREFERENCE_AM_SERVICING_CONTACT_REASSIGNED"] = "CLIENT_PREFERENCE_AM_SERVICING_CONTACT_REASSIGNED";
    SecondaryCancellationReason["CLIENT_PREFERENCE_CLIENT_REQUESTED_CANCEL_WITHOUT_CONTEXT"] = "CLIENT_PREFERENCE_CLIENT_REQUESTED_CANCEL_WITHOUT_CONTEXT";
    SecondaryCancellationReason["CLIENT_PREFERENCE_INSURANCE_BUYER_CHANGED"] = "CLIENT_PREFERENCE_INSURANCE_BUYER_CHANGED";
    SecondaryCancellationReason["CLIENT_PREFERENCE_ISSUES_WITH_INTERPERSONAL_RELATIONSHIP"] = "CLIENT_PREFERENCE_ISSUES_WITH_INTERPERSONAL_RELATIONSHIP";
    SecondaryCancellationReason["CLIENT_PREFERENCE_REQUIRED_FASTER_TURNAROUND_TIMES"] = "CLIENT_PREFERENCE_REQUIRED_FASTER_TURNAROUND_TIMES";
    SecondaryCancellationReason["CLIENT_PREFERENCE_REQUIRED_MORE_CERTS_SUPPORT"] = "CLIENT_PREFERENCE_REQUIRED_MORE_CERTS_SUPPORT";
    SecondaryCancellationReason["CLIENT_PREFERENCE_REQUIRED_MORE_CLAIMS_RISK_MANAGEMENT_SUPPORT"] = "CLIENT_PREFERENCE_REQUIRED_MORE_CLAIMS_RISK_MANAGEMENT_SUPPORT";
    SecondaryCancellationReason["CLIENT_PREFERENCE_REQUIRED_SPECIALIZED_EXPERTISE"] = "CLIENT_PREFERENCE_REQUIRED_SPECIALIZED_EXPERTISE";
    SecondaryCancellationReason["CONSOLIDATED_TO_PACKAGE"] = "CONSOLIDATED_TO_PACKAGE";
    SecondaryCancellationReason["CUSTOMER_COMPLIANCE_CLIENT_DID_NOT_MEET_CARRIER_REQS"] = "CUSTOMER_COMPLIANCE_CLIENT_DID_NOT_MEET_CARRIER_REQS";
    SecondaryCancellationReason["CUSTOMER_COMPLIANCE_MISREPRESENTED_CLIENT_EXPOSURE"] = "CUSTOMER_COMPLIANCE_MISREPRESENTED_CLIENT_EXPOSURE";
    SecondaryCancellationReason["CUSTOMER_COMPLIANCE_NON_PAYMENT"] = "CUSTOMER_COMPLIANCE_NON_PAYMENT";
    SecondaryCancellationReason["CUSTOMER_UNRESPONSIVE"] = "CUSTOMER_UNRESPONSIVE";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_BLOCKED"] = "NF_UNABLE_TO_PLACE_COVERAGE_BLOCKED";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_CLIENT_WANTED_TO_APPROACH_MORE_MARKETS"] = "NF_UNABLE_TO_PLACE_COVERAGE_CLIENT_WANTED_TO_APPROACH_MORE_MARKETS";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_CUSTOMER_NOT_GOOD_FIT"] = "NF_UNABLE_TO_PLACE_COVERAGE_CUSTOMER_NOT_GOOD_FIT";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_DID_NOT_HAVE_MARKET_ACCESS"] = "NF_UNABLE_TO_PLACE_COVERAGE_DID_NOT_HAVE_MARKET_ACCESS";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_LOST_ON_PRICING"] = "NF_UNABLE_TO_PLACE_COVERAGE_LOST_ON_PRICING";
    SecondaryCancellationReason["NF_UNABLE_TO_PLACE_COVERAGE_QUOTING_PROCESS_DELAYED"] = "NF_UNABLE_TO_PLACE_COVERAGE_QUOTING_PROCESS_DELAYED";
    SecondaryCancellationReason["NO_LONGER_NEED_INSURANCE_BUSINESS_SHUT_DOWN"] = "NO_LONGER_NEED_INSURANCE_BUSINESS_SHUT_DOWN";
    SecondaryCancellationReason["NO_LONGER_NEED_INSURANCE_INSURED_ENTITY_NO_LONGER_REQUIRES_COVERAGE"] = "NO_LONGER_NEED_INSURANCE_INSURED_ENTITY_NO_LONGER_REQUIRES_COVERAGE";
    SecondaryCancellationReason["NO_LONGER_NEED_INSURANCE_NON_RECURRING_COVERAGE"] = "NO_LONGER_NEED_INSURANCE_NON_RECURRING_COVERAGE";
    SecondaryCancellationReason["OTHER"] = "OTHER";
    SecondaryCancellationReason["PRODUCER_LEFT_NEWFRONT"] = "PRODUCER_LEFT_NEWFRONT";
})(SecondaryCancellationReason = exports.SecondaryCancellationReason || (exports.SecondaryCancellationReason = {}));
var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["ACTIVE"] = "ACTIVE";
    PolicyStatus["EXPIRED"] = "EXPIRED";
    PolicyStatus["CANCELLED"] = "CANCELLED";
    PolicyStatus["UPCOMING"] = "UPCOMING";
})(PolicyStatus = exports.PolicyStatus || (exports.PolicyStatus = {}));
var PolicyStage;
(function (PolicyStage) {
    PolicyStage["NEW"] = "NEW";
    PolicyStage["NEW_BOR"] = "NEW_BOR";
    PolicyStage["BOR"] = "BOR";
    PolicyStage["RENEWAL"] = "RENEWAL";
    PolicyStage["REWRITTEN"] = "REWRITTEN";
    PolicyStage["ACQUIRED"] = "ACQUIRED";
    PolicyStage["BOR_LOST"] = "BOR_LOST";
    PolicyStage["OUT_OF_BUSINESS"] = "OUT_OF_BUSINESS";
    PolicyStage["NON_PAYMENT"] = "NON_PAYMENT";
    PolicyStage["OUTSIDE_CARRIER_APPETITE"] = "OUTSIDE_CARRIER_APPETITE";
    PolicyStage["POOR_LOSS_HISTORY"] = "POOR_LOSS_HISTORY";
    PolicyStage["HISTORICAL"] = "HISTORICAL";
})(PolicyStage = exports.PolicyStage || (exports.PolicyStage = {}));
var OriginatedVia;
(function (OriginatedVia) {
    OriginatedVia["AUTO_RENEWAL"] = "AUTO_RENEWAL";
    OriginatedVia["RENEWAL_WITH_INCUMBENT"] = "RENEWAL_WITH_INCUMBENT";
    OriginatedVia["REMARKET"] = "REMARKET";
})(OriginatedVia = exports.OriginatedVia || (exports.OriginatedVia = {}));
var PolicyNFType;
(function (PolicyNFType) {
    PolicyNFType["NEW_BUSINESS"] = "NEW_BUSINESS";
    PolicyNFType["RENEWAL"] = "RENEWAL";
    PolicyNFType["REWRITE"] = "REWRITE";
    PolicyNFType["NONE"] = "NONE";
})(PolicyNFType = exports.PolicyNFType || (exports.PolicyNFType = {}));
var PolicyBillingType;
(function (PolicyBillingType) {
    PolicyBillingType["DIRECT"] = "DIRECT";
    PolicyBillingType["DIRECT_FINANCED"] = "DIRECT_FINANCED";
    PolicyBillingType["DIRECT_INSTALLMENTS"] = "DIRECT_INSTALLMENTS";
    PolicyBillingType["AGENT"] = "AGENT";
    PolicyBillingType["FINANCED"] = "FINANCED";
    PolicyBillingType["INSTALLMENTS"] = "INSTALLMENTS";
})(PolicyBillingType = exports.PolicyBillingType || (exports.PolicyBillingType = {}));
var PolicyAssignmentRole;
(function (PolicyAssignmentRole) {
    PolicyAssignmentRole["PRODUCER"] = "PRODUCER";
    PolicyAssignmentRole["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
})(PolicyAssignmentRole = exports.PolicyAssignmentRole || (exports.PolicyAssignmentRole = {}));
var CantAssignUserToPolicyWarning;
(function (CantAssignUserToPolicyWarning) {
    CantAssignUserToPolicyWarning["NOT_AM"] = "Employee is not an account manager";
    CantAssignUserToPolicyWarning["NOT_FOUND"] = "Employee not found";
    CantAssignUserToPolicyWarning["NOT_PRODUCER"] = "Employee is not a producer";
    CantAssignUserToPolicyWarning["UNKNOWN"] = "Unknown";
})(CantAssignUserToPolicyWarning = exports.CantAssignUserToPolicyWarning || (exports.CantAssignUserToPolicyWarning = {}));
//# sourceMappingURL=policy.js.map